<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="800"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="注册eIM"
      @ok="handleSubmit"
    >
      <a-row>
        <a-form class="simiot-compact-form" :form="form" @submit="handleSubmit">
          <a-col :span="24">
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-textarea
                :rows="12"
                :placeholder="iccidPlaceholder"
                :style="{ color: iccidValidateStatus === 'error' ? 'red' : '' }"
                v-model.trim="iccidInput"
                @blur="analyzeIccidInput"
              />
            </a-form-item>
            <a-form-item label="ICCID总数" :style="{ display: 'inline-block', width: '50%' }">
              <span>{{ iccidsCount }}</span>
            </a-form-item>
            <a-form-item label="重复数量" :style="{ display: 'inline-block', width: '50%' }">
              <span>{{ duplicateIccidsCount }}</span>
            </a-form-item>
            <div v-if="iccidErrorMsg" style="color: red">{{ iccidErrorMsg }}</div>
          </a-col>
          <a-col :span="24">
            <a-form-item label="eIM平台">
              <a-select
                v-decorator="['eim_platform_id', { rules: [{ required: true, message: '请选择eIM平台' }] }]"
                :loading="loadingEimPlatformOptions"
                placeholder="请选择"
              >
                <a-select-option v-for="opt in eimPlatformOptions" :key="opt.id" :value="opt.id">
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="重复下载规则（EIM）">
              <a-select
                v-decorator="['prp_rule_id', { rules: [{ required: true, message: '请选择重复下载规则（EIM）' }] }]"
                :loading="loadingPrpOptions"
                placeholder="请选择"
              >
                <a-select-option v-for="opt in prpOptions" :key="opt.id" :value="opt.id">
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="备注">
              <a-textarea
                v-decorator="['remark', { rules: [{ max: 200, message: '最多200个字符' }] }]"
                :auto-size="{ minRows: 2, maxRows: 4 }"
              />
            </a-form-item>
          </a-col>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { registerProfilesToEim } from '@/api/profile'
import { findCommonTypeOptions } from '@/api/common_type'
import { analyzeIccids, maxIccidLines } from '@/utils/iccid'

export default {
  name: 'BatchOperationsRegisterProfileToEim',
  props: {
    visible: { type: Boolean, required: true },
    agentId: { type: Number, required: true },
    iccids: { type: Array, default() { return [] } }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'register_profile_to_eim' }),
      submitting: false,
      iccidInput: (this.iccids || []).join('\n'),
      parsedIccids: [],
      iccidsCount: 0,
      duplicateIccidsCount: 0,
      iccidValidateStatus: '',
      iccidErrorMsg: '',
      prpOptions: [],
      loadingPrpOptions: false,
      eimPlatformOptions: [],
      loadingEimPlatformOptions: false,
      iccidPlaceholder: '可以直接复制excel中整列ICCID；\n' +
        '手动输入多个ICCID，一行一个；\n' +
        '连号的ICCID只需要输入最后几位不一样的即可，用波浪线连接。'
    }
  },
  computed: {
    isShow: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  created() {
    this.fetchEimPlatformOptions()
    this.fetchPrpOptions()
    if (this.iccidInput) {
      this.analyzeIccidInput()
    }
  },
  methods: {
    fetchEimPlatformOptions() {
      this.loadingEimPlatformOptions = true
      findCommonTypeOptions('eim_platform').then((res) => {
        if (res.code === 0) this.eimPlatformOptions = res.data
        this.loadingEimPlatformOptions = false
      })
    },

    fetchPrpOptions() {
      this.loadingPrpOptions = true
      findCommonTypeOptions('profile_prp_code').then((res) => {
        if (res.code === 0) this.prpOptions = res.data
        this.loadingPrpOptions = false
      })
    },

    analyzeIccidInput() {
      if (!this.iccidInput) {
        this.parsedIccids = []
        this.iccidsCount = 0
        this.duplicateIccidsCount = 0
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = '请输入 ICCID'
        return
      }

      const { lines, validIccids, errorText } = analyzeIccids(this.iccidInput)
      if (lines > maxIccidLines) {
        this.parsedIccids = []
        this.iccidsCount = 0
        this.duplicateIccidsCount = 0
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = `ICCID数量不能超过${maxIccidLines}`
        return
      }

      this.iccidInput = errorText + validIccids.join('\n')
      this.parsedIccids = this.$lodash.uniq(validIccids)
      this.iccidsCount = validIccids.length
      this.duplicateIccidsCount = validIccids.length - this.parsedIccids.length

      if (errorText) {
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = '号码包含错误，无法提交'
      } else if (this.parsedIccids.length === 0) {
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = '请输入 ICCID'
      } else if (this.duplicateIccidsCount > 0) {
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = '录入的 ICCID 存在重复'
      } else {
        this.iccidValidateStatus = 'success'
        this.iccidErrorMsg = ''
      }
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }
      this.analyzeIccidInput()
      if (this.iccidValidateStatus === 'error') {
        return
      }
      this.form.validateFields((err, values) => {
        if (err) return
        this.submitting = true
        registerProfilesToEim({
          agent_id: this.agentId,
          iccids: this.parsedIccids,
          eim_platform_id: values.eim_platform_id,
          prp_rule_id: values.prp_rule_id,
          remark: values.remark || ''
        }).then((res) => {
          if (res.code === 0) {
            this.isShow = false
            this.$emit('completed')
            this.$success({
              title: '提交成功',
              content: (<div><p>注册eIM任务已提交，请在批量操作查询中查看结果</p></div>)
            })
          }
          this.submitting = false
        }).catch(() => { this.submitting = false })
      })
    }
  }
}
</script>
